import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Influencer.css';

const PARTNERSHIP_TIERS = [
  {
    name: 'Micro',
    followers: 'Under 50K',
    perks: [
      'Base payment',
      'Performance bonus for every 50 signups via your link',
      'Featured list slot for 6 months',      
      'Vibary Premium for life',
      'Creator community access (Discord)'
    ],
    deliverables: [
      '3 public lists (10+ places each)',
      '1 Instagram, TikTok, or YouTube audio promotion',
      'Link to one of your Vibary lists from a post',
      'Link to your Vibary profile in your social media bio/bio site for 30 days'
    ]
  },
  {
    name: 'Mid-Tier',
    followers: '50K - 200K',
    perks: [
      'Enhanced base payment',
      'Performance bonus for every 50 signups via your link',
      'Featured list slot for 6 months',      
      'Vibary Premium for life',
      'Creator community access (Discord)'
    ],
    deliverables: [
      '3 public lists (10+ places each)',
      '1 Instagram, TikTok, or YouTube audio promotion',
      'Link to one of your Vibary lists from a post',
      'Link to your Vibary profile in your social media bio/bio site for 30 days'
    ]
  },
  {
    name: 'Ambassador',
    followers: '200K+',
    perks: [
      'Revenue share on Premium conversions with guaranteed minimum',
      '"Founding Creator" title with prominent placement',
      'Cross-promotion in launch PR/marketing',
      'Product input & feature prioritization',
      'Vibary Premium for life',
      'Creator community access (Discord)'
    ],
    deliverables: [
      'Custom partnership',
      'Long-term collaboration',
      'Potential co-marketing'
    ]
  }
];


const CONTENT_IDEAS = [
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
        <circle cx="8.5" cy="8.5" r="1.5" />
        <polyline points="21 15 16 10 5 21" />
      </svg>
    ),
    title: '"My Top 10" List Reveal',
    description: 'Share your curated list of favorite spots in your city. Perfect for short-form or long-form with a genuine rec style.'
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
        <circle cx="12" cy="10" r="3" />
      </svg>
    ),
    title: 'Map Tour Walkthrough',
    description: 'Show your audience how you explore a new city or neighborhood using your Vibary map view. Great for exploration-style content.'
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
    title: 'Collab List with Friends',
    description: 'Create a collaborative list with another creator and share the process. Perfect for cross-promotion.'
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
      </svg>
    ),
    title: 'Hidden Gems Series',
    description: 'Feature your "Gem" rated spots - the places you rave about. Resonates with audiences asking "what\'s your favorite ____?!"'
  }
];


function TierCard({ tier }) {
  return (
    <div className="influencer-tier-card">
      <div className="influencer-tier-header">
        <h3 className="influencer-tier-name">{tier.name}</h3>
        <p className="influencer-tier-followers">{tier.followers} followers</p>
      </div>

      <div className="influencer-tier-section influencer-tier-perks-section">
        <h4>What You Get</h4>
        <ul className="influencer-tier-perks">
          {tier.perks.map((perk, index) => (
            <li key={index}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <polyline points="20 6 9 17 4 12" />
              </svg>
              {perk}
            </li>
          ))}
        </ul>
      </div>

      <div className="influencer-tier-section influencer-tier-deliverables-section">
        <h4>Deliverables</h4>
        <ul className="influencer-tier-deliverables">
          {tier.deliverables.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}

function ContentIdeaCard({ idea }) {
  return (
    <div className="influencer-idea-card">
      <div className="influencer-idea-icon">{idea.icon}</div>
      <h4 className="influencer-idea-title">{idea.title}</h4>
      <p className="influencer-idea-description">{idea.description}</p>
    </div>
  );
}

function Influencer() {
  const navigate = useNavigate();

  const handleApply = () => {
    window.open('https://docs.google.com/forms/d/e/1FAIpQLSe7qf9OaFRM7S2HgoejEqpWChWN0qBRZqLjhTEC8XIgqrurug/viewform?usp=header', '_blank');
  };

  const handleDownloadKit = () => {
    navigate('/media-kit');
  };

  return (
    <div className="influencer-container">
      {/* Header */}
      <header className="influencer-header">
        <div className="influencer-header-content">
          <a href="/" className="influencer-home-link" onClick={(e) => { e.preventDefault(); navigate('/'); }}>
            Home
          </a>
          <div className="influencer-header-brand">
            <img src="/vibary-icon-rounded.png" alt="Vibary" className="influencer-header-logo" />
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="influencer-hero">
        <div className="influencer-hero-content">
          <div className="influencer-hero-badge">Founding Creator Program</div>
          <h1 className="influencer-hero-title">
            Become a Founding Creator.<br />
            <span className="influencer-hero-accent">Shape how SF discovers places.</span>
          </h1>
          <p className="influencer-hero-subtitle">
            We're building a group of local tastemakers to be founding creators on Vibary.
            Your content inspires discoveries - now turn those recommendations into something your audience can save, explore, and return to.
          </p>
          <div className="influencer-hero-buttons">
            <button className="influencer-btn-primary" onClick={handleApply}>
              Apply Now
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </button>
            <button className="influencer-btn-secondary" onClick={handleDownloadKit}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
              </svg>
              View Media Kit
            </button>
          </div>
        </div>
        <div className="influencer-hero-visual">
          <div className="influencer-phone-mockup">
            <div className="influencer-phone-screen">
              <img
                src="https://images.unsplash.com/photo-1536256263959-770b48d82b0a?w=600&q=80"
                alt="Vibary app screenshot"
                className="influencer-phone-image"
              />
              <div className="influencer-phone-overlay">
                <div className="influencer-phone-list-card">
                  <span className="influencer-phone-list-title">Bay Area Matcha Spots</span>
                  <span className="influencer-phone-list-meta">12 places</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Partner Section */}
      <section className="influencer-why-section">
        <div className="influencer-section-header">
          <h2>Why creators love Vibary</h2>
          <p>Your content is exactly the vibe we're going for</p>
        </div>

        <div className="influencer-why-grid">
          <div className="influencer-why-card">
            <div className="influencer-why-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
              </svg>
            </div>
            <h3>Your recommendations, preserved</h3>
            <p>Your lists live on, always accessible to your audience. Especially when they're on the go.</p>
          </div>

          <div className="influencer-why-card">
            <div className="influencer-why-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <circle cx="18" cy="5" r="3" />
                <circle cx="6" cy="12" r="3" />
                <circle cx="18" cy="19" r="3" />
                <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
                <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
              </svg>
            </div>
            <h3>Shareable & trackable</h3>
            <p>Every list you create can be shared with a single link. Track how many people view and follow your recommendations.</p>
          </div>

          <div className="influencer-why-card">
            <div className="influencer-why-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
            </div>
            <h3>Find new audiences</h3>
            <p>Add links to your lists to drive traffic to your YouTube, blog, or other content. Turn place recommendations into new followers.</p>
          </div>

          <div className="influencer-why-card">
            <div className="influencer-why-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
              </svg>
            </div>
            <h3>Builds real engagement</h3>
            <p>When followers save your lists, they come back again and again. It's a lasting touchpoint, not a fleeting story.</p>
          </div>
        </div>
      </section>

      {/* Partnership Tiers Section */}
      <section className="influencer-tiers-section">
        <div className="influencer-section-header">
          <h2>Partnership opportunities</h2>
          <p>Building a lasting collaboration</p>
        </div>

        <div className="influencer-tiers-grid">
          {PARTNERSHIP_TIERS.map((tier, index) => (
            <TierCard key={index} tier={tier} />
          ))}
        </div>
      </section>

      {/* Content Ideas Section */}
      <section className="influencer-ideas-section">
        <div className="influencer-section-header">
          <h2>Content ideas to get you started</h2>
          <p>Formats that resonate with audiences</p>
        </div>

        <div className="influencer-ideas-grid">
          {CONTENT_IDEAS.map((idea, index) => (
            <ContentIdeaCard key={index} idea={idea} />
          ))}
        </div>
      </section>

      {/* How It Works Section */}
      <section className="influencer-process-section">
        <div className="influencer-section-header">
          <h2>How it works</h2>
          <p>From application to partnership in 4 simple steps</p>
        </div>

        <div className="influencer-process-grid">
          <div className="influencer-process-step">
            <div className="influencer-process-number">1</div>
            <h3>Apply</h3>
            <p>Fill out a quick application with your social handles and content focus.</p>
          </div>
          <div className="influencer-process-step">
            <div className="influencer-process-number">2</div>
            <h3>Connect</h3>
            <p>We'll schedule a quick call to walk through the app and discuss the partnership.</p>
          </div>
          <div className="influencer-process-step">
            <div className="influencer-process-number">3</div>
            <h3>Onboard</h3>
            <p>Get your Premium account, join the creator community, and start building your lists.</p>
          </div>
          <div className="influencer-process-step">
            <div className="influencer-process-number">4</div>
            <h3>Launch</h3>
            <p>Create content during launch week and watch your audience discover their new favorite spots.</p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="influencer-cta-section">
        <div className="influencer-cta-content">
          <h2>Ready to become a Founding Creator?</h2>
          <p>We're launching in SF first, then expanding to LA/SD. Get in early and help shape the platform.</p>
          <button className="influencer-btn-primary influencer-btn-large" onClick={handleApply}>
            Apply to Founding Creator Program
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </button>
          <p className="influencer-cta-note">Questions? DM us on <a href="https://www.instagram.com/getvibary/" target="_blank" rel="noopener noreferrer">Instagram</a> or email <a href="mailto:support@getvibary.com">support@getvibary.com</a></p>
        </div>
      </section>

      {/* Footer */}
      <footer className="influencer-footer">
        <div className="influencer-footer-content">
          <div className="influencer-footer-brand">
            <img src="/vibary-wordmark-light.png" alt="Vibary" className="influencer-footer-logo" />
          </div>
          <div className="influencer-footer-links">
            <a href="/" onClick={(e) => { e.preventDefault(); navigate('/'); }}>Home</a>
            <a href="/legal/privacy">Privacy Policy</a>
            <a href="/legal/terms">Terms of Service</a>
          </div>
          <p className="influencer-footer-copyright">
            © {new Date().getFullYear()} Vibary. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default Influencer;
